import { useEffect } from 'react';
import { useSharedState } from '../hooks/SharedStateContext';

const TimeMonitor = ({ setHasTimeLimitExceeded }) => {
  const { sharedState, setSharedState } = useSharedState();

  useEffect(() => {
    // Load the usage time from local storage or initialize it
    const loadUsageTime = () => {
      const storedUsage = JSON.parse(localStorage.getItem('usageTime')) || {};
      const today = new Date().toDateString();
      return storedUsage[today] || 0;
    };

    const saveUsageTime = (time) => {
      const storedUsage = JSON.parse(localStorage.getItem('usageTime')) || {};
      const today = new Date().toDateString();
      storedUsage[today] = time;
      localStorage.setItem('usageTime', JSON.stringify(storedUsage));
    };

    // Reset usage time at the beginning of each day
    const resetUsageTime = () => {
      const storedUsage = JSON.parse(localStorage.getItem('usageTime')) || {};
      const today = new Date().toDateString();
      storedUsage[today] = 0;
      localStorage.setItem('usageTime', JSON.stringify(storedUsage));
    };

    // Check if we need to reset the usage time
    const today = new Date().toDateString();
    const storedUsage = JSON.parse(localStorage.getItem('usageTime')) || {};
    if (!storedUsage[today]) {
      resetUsageTime();
    }

    let usageTime = loadUsageTime();
    let previousTime = Date.now();

    // Initial check to see if the user has already reached the time limit
    if (sharedState.timeLimit && usageTime >= sharedState.timeLimit) {
      setSharedState(prevState => ({
        ...prevState,
        loading: false,
        talking: false,
        recording: false,
        lastRecordedBlob: null, // Clear the last response.
      }));
      setHasTimeLimitExceeded(true);
    }

    const interval = setInterval(() => {
      if (sharedState.timeLimit) {
        const currentTime = Date.now();
        const elapsedTime = (currentTime - previousTime) / 1000 / 60; // in minutes
        previousTime = currentTime;

        usageTime += elapsedTime;
        saveUsageTime(usageTime);

        if (usageTime >= sharedState.timeLimit) {
          setSharedState(prevState => ({
            ...prevState,
            loading: false,
            talking: false,
            recording: false,
            lastRecordedBlob: null, // Clear the last response.
          }));
          setHasTimeLimitExceeded(true);
        } else {
          setHasTimeLimitExceeded(false);
        }
      }
    }, 15000); // check every 15 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, [sharedState.timeLimit, sharedState.startTime, setSharedState, setHasTimeLimitExceeded]);

  return null; // This component does not render anything
};

export default TimeMonitor;
